export default {
  methods: {
    showDialog(mutationName) {
      this.$store.commit(mutationName, true)
    },
    hideDialog(mutationName) {
      this.$store.commit(mutationName, false)
    }
  }
}
